__turbopack_context__.v({
  "categoryScope": "styles-module__eyMfPG__categoryScope",
  "errorBox": "styles-module__eyMfPG__errorBox",
  "sidebar": "styles-module__eyMfPG__sidebar",
  "socialIcon": "styles-module__eyMfPG__socialIcon",
});
